import {Link} from "react-router-dom";

export default () => {
  return <div className="account-forget">
    <Link to="/forget-find" className="item">我忘记了密码</Link>
    <Link to="/service" className="item">我忘记了账号</Link>
    <Link to="/service" className="item">我忘记了账号和密码</Link>
  </div>
};